import gql from "graphql-tag";

const RESEND_LEAD_APPOINTMENT_CONFIRMATION = gql`
  mutation resendLeadAppointmentConfirmation($appointment_id: ID!) {
    resendLeadAppointmentConfirmation(appointment_id: $appointment_id) {
      message
      code
    }
  }
`;

export default RESEND_LEAD_APPOINTMENT_CONFIRMATION;
